import React from 'react';
import Img from '../../../Img';
import BackgroundImage from '../../../BackgroundImage';

const Avatar = props => {
    const { playerImages, nationality } = props;
    const nationalFlag = nationality ? `/img/flags/${nationality.toLowerCase()}.svg` : '';
    return (
        <div className="avatar-container ml-auto">
            <BackgroundImage
                baseUrl={'/v1/player/'}
                defaultImage={'/img/v2/icons/icon-avatar-player.svg'}
                images={playerImages}
                imageType={'icon'}
                parentStylesClass={'avatar'}
            />
            {nationality && (
                <div className="flag-container">
                    <Img
                        className="flag"
                        src={nationalFlag}
                        alt={nationality}
                    />
                </div>
            )}
        </div>
    );
};

export default Avatar;
